import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { LoadingStateService } from '../services/loading-state/loading-state.service';

export class LoadingInterceptor implements HttpInterceptor {
    private loadingStateService = inject(LoadingStateService);
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.loadingStateService.setIsLoading(true, request.url);
        return next.handle(request).pipe(
            catchError((err) => {
                this.loadingStateService.setIsLoading(false, request.url);
                return throwError(() => err);
            }),
            tap((event) => {
                if (event instanceof HttpResponse) {
                    this.loadingStateService.setIsLoading(false, request.url);
                }
            })
        );
    }
}
